
import AuthModule from '../../store/auth.module'
import user from '../../model/user'
import {defineComponent, ref } from 'vue'
import message from '../../model/message'
import response from "@/model/response";
import { useI18n } from 'vue-i18n';

export default defineComponent({
    setup() {
      const {t,locale} = useI18n({useScope:'global'})
        const lang= ref({label:"English", value:'en'})
        const loading = ref(false);
        const message = ref("");
        const successful = ref(false);

        return {
            t,
            locale,
            lang,
            loading,
            message,
            successful,
            options: [
         {label:'English', value:'en'},
        {label:'Русский', value:'ru'},
        {label:'Español', value:'es'}
      ]
        }
    },
computed: {
  currentUser():user {
      return AuthModule.currentUser;
    },
  },
  mounted():void {
    if (!this.currentUser) {
      this.$router.push('/login');
    }
    else{
        this.lang = this.options.find(loc=>loc.value===this.currentUser.locale)
        
    }
  },
  methods: {
    handleUpdate() {
      this.message = "";
      this.successful = false;
      this.loading = true;
      let data:user = {} as user;
   this.locale = this.lang.value
   localStorage.setItem('lang',this.locale)
      data.locale = this.lang.value
      AuthModule.updatelocale(data).then(
        (data:response) => {
          this.message = (data.body as message).message;
          if (data.statusCodeValue==200)
            this.successful = true;
          else
            this.successful  =  false;
          this.loading = false;
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
  },
},
})
